import React from "react";

import icon from "./icon.png";

function DefaultIcon({ className }: { className: string }) {
  return <img className={className} src={icon} />;
}

export { DefaultIcon };
